__webpack_require__.p = "/reports-req-details-display-all/referrals-hub/";